/**
 * Supabase Client Instance
 * Simple export for use in services
 */

import { createClient } from '@supabase/supabase-js';

// Fallback to hardcoded values if env variables are not loaded
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || process.env.REACT_APP_SUPABASE_URL || 'https://gpittnsfzgkdbqnccncn.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdwaXR0bnNmemdrZGJxbmNjbmNuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjMxMDE3MzIsImV4cCI6MjA3ODY3NzczMn0.4jrpZ_7Wd_ELFjCH105iBqyFPmZmKxI06U0EyqTT5xo';

// Validate configuration (no logging in production)
if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

if (!supabaseUrl.startsWith('http')) {
  throw new Error('Invalid Supabase URL format');
}

// Only log in development
if (import.meta.env.DEV) {
  console.log('✅ Supabase client initialized');
}

/**
 * Custom storage adapter that checks rememberMe preference
 * and uses appropriate storage (localStorage or sessionStorage)
 */
const customStorage = {
  getItem: (key: string) => {
    // Check both storages
    return localStorage.getItem(key) || sessionStorage.getItem(key);
  },
  setItem: (key: string, value: string) => {
    // Use appropriate storage based on rememberMe preference
    const rememberMe = localStorage.getItem('rememberMe') === 'true';
    const storage = rememberMe ? localStorage : sessionStorage;
    storage.setItem(key, value);
  },
  removeItem: (key: string) => {
    // Remove from both storages to be safe
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  },
};

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true, // Auto-refresh token before expiry
    persistSession: true, // Always persist, but storage type depends on rememberMe
    detectSessionInUrl: true, // Detect session from URL (for OAuth)
    storage: customStorage as any, // Use custom storage adapter
  },
  realtime: {
    params: {
      eventsPerSecond: 10, // Limit events to prevent flooding
    },
    timeout: 30000, // 30 second timeout for Realtime connections
  },
  global: {
    headers: {
      'X-Client-Info': 'canvango-web-app', // Custom header for tracking
    },
  },
});
